import script from "./LegalAffairs.vue?vue&type=script&lang=ts&setup=true"
export * from "./LegalAffairs.vue?vue&type=script&lang=ts&setup=true"

import "./LegalAffairs.vue?vue&type=style&index=0&id=1940258c&lang=less"

const __exports__ = script;

export default __exports__